<template>
  <div>
    <sy-out />
  </div>
</template>

<script>
// 获取接口地址
import SyOut from '../components/syck/syOut.vue'

export default {
  name: 'Syck',
  components: {
    // sideMenu,
    // Header,
    SyOut
  },
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style scoped>
</style>
